const migrations = {
  2: (state) => ({
    ...state,
    search: {
      ...state.search,
      __next: "",
    },
  }),
  3: (state) => ({
    ...state,
    auth: {
      ...state.auth,
      changePassword: {
        isInProgress: false,
      },
    },
  }),
  4: (state) => ({
    ...state,
    search: {
      ...state.search,
      filters: {
        ...state.search.filters,
        byId: {
          ...state.search.filters.byId,
          sup: { id: "sup", placeholder: "Supplier" },
        },
      },
    },
  }),
  5: (state) => ({
    ...state,
    salesAgents: {
      ids: state.salesAgents.ids,
      entities: state.salesAgents.entities,
    },
  }),
  6: ({ search, subAgencies, ...state }) => ({
    ...state,
    search: {
      ...search,
      filters: {
        ...search.filters,
        applied: search.filters.applied.filter((f) => f !== "suba"),
        byId: (({ suba, ...byId }) => byId)(search.filters.byId),
      },
    },
  }),
  7: (state) => ({
    ...state,
    search: {
      ...state.search,
      filters: {
        ...state.search.filters,
        byId: {
          ...state.search.filters.byId,
          flightDates: { id: "flightDates", placeholder: "Flight Dates" },
        },
      },
    },
  }),
  8: (state) => ({
    ...state,
    search: {
      ...state.search,
      filters: {
        ...state.search.filters,
        byId: (({ gds, ...rest }) => ({
          ...rest,
          src: { id: "src", placeholder: "Source" },
        }))(state.search.filters.byId),
      },
    },
  }),
  9: (state) => ({
    ...state,
    search: {
      ...state.search,
      filters: {
        ...state.search.filters,
        byId: (({ recordLocator, ...rest }) => ({
          ...rest,
          pnr: { id: "pnr", placeholder: "PNR" },
        }))(state.search.filters.byId),
      },
    },
  }),
  10: (state) => ({
    ...state,
    suppliers: {
      ...state.suppliers,
      edit: {
        id: null,
        isNew: false,
        isSaving: false,
      },
    },
  }),
  11: (state) => ({
    ...state,
    coa: {
      ids: [],
      entities: {},
      edit: { id: null, isSaving: false },
    },
  }),
};

export default migrations;
